/**
 * Blog Registry/Manifest
 * Contains metadata for all curated blog posts
 */

export const BLOG_CATEGORIES = {
  'llc-basics': {
    id: 'llc-basics',
    label: {
      es: 'LLC Básicos',
      en: 'LLC Basics',
    },
    color: 'primary',
  },
  banking: {
    id: 'banking',
    label: {
      es: 'Banca',
      en: 'Banking',
    },
    color: 'secondary',
  },
  taxes: {
    id: 'taxes',
    label: {
      es: 'Impuestos',
      en: 'Taxes',
    },
    color: 'accent',
  },
  'country-guides': {
    id: 'country-guides',
    label: {
      es: 'Guías por País',
      en: 'Country Guides',
    },
    color: 'info',
  },
  payments: {
    id: 'payments',
    label: {
      es: 'Pagos',
      en: 'Payments',
    },
    color: 'success',
  },
  regulations: {
    id: 'regulations',
    label: {
      es: 'Regulaciones',
      en: 'Regulations',
    },
    color: 'warning',
  },
};

export const blogs = [
  {
    id: 'que-es-una-llc',
    slug: 'que-es-una-llc',
    category: 'llc-basics',
    featured: true,
    publishedAt: '2025-01-01',
    readingTime: 12,
    author: 'Rely',
    title: {
      es: 'Qué es una LLC y por qué la necesitás si sos freelancer o tenés un negocio digital',
      en: 'What is an LLC and why you need one if you are a freelancer or have a digital business',
    },
    excerpt: {
      es: 'Si llegaste hasta acá, probablemente ya escuchaste hablar de las LLC. En esta guía vas a aprender qué es exactamente una LLC, cómo funciona, y por qué miles de emprendedores de Latinoamérica están abriendo una.',
      en: 'If you made it here, you probably already heard about LLCs. In this guide you will learn what an LLC is, how it works, and why thousands of Latin American entrepreneurs are opening one.',
    },
    file: '01_que_es_una_llc',
  },
  {
    id: 'por-que-wyoming',
    slug: 'por-que-wyoming',
    category: 'llc-basics',
    featured: true,
    publishedAt: '2025-01-02',
    readingTime: 10,
    author: 'Rely',
    title: {
      es: 'Por qué Wyoming es el mejor estado para abrir tu LLC si sos extranjero',
      en: 'Why Wyoming is the best state to open your LLC if you are a foreigner',
    },
    excerpt: {
      es: 'Descubrí por qué Wyoming se convirtió en el estado favorito para emprendedores internacionales: sin impuestos estatales, máxima privacidad y costos bajos.',
      en: 'Discover why Wyoming has become the favorite state for international entrepreneurs: no state taxes, maximum privacy and low costs.',
    },
    file: '02_por_que_wyoming',
  },
  {
    id: 'como-abrir-cuenta-mercury-relay',
    slug: 'como-abrir-cuenta-mercury-relay',
    category: 'banking',
    featured: true,
    publishedAt: '2025-01-03',
    readingTime: 15,
    author: 'Rely',
    title: {
      es: 'Cómo abrir una cuenta bancaria en Mercury o Relay para tu LLC',
      en: 'How to open a bank account in Mercury or Relay for your LLC',
    },
    excerpt: {
      es: 'Guía paso a paso para abrir tu cuenta bancaria empresarial en Estados Unidos. Comparamos Mercury vs Relay y te mostramos cómo maximizar tus chances de aprobación.',
      en: 'Step by step guide to open your business bank account in the United States. We compare Mercury vs Relay and show you how to maximize your approval chances.',
    },
    file: '03_como_abrir_cuenta_mercury_relay',
  },
  {
    id: 'stripe-para-latinoamerica',
    slug: 'stripe-para-latinoamerica',
    category: 'payments',
    featured: false,
    publishedAt: '2025-01-04',
    readingTime: 12,
    author: 'Rely',
    title: {
      es: 'Stripe para Latinoamérica: cómo usar el mejor procesador de pagos con tu LLC',
      en: 'Stripe for Latin America: how to use the best payment processor with your LLC',
    },
    excerpt: {
      es: 'Stripe es el estándar de la industria, pero no opera en la mayoría de países de Latam. Aprendé cómo configurarlo con tu LLC y empezá a cobrar profesionalmente.',
      en: 'Stripe is the industry standard, but it does not operate in most Latin American countries. Learn how to set it up with your LLC and start collecting payments professionally.',
    },
    file: '04_stripe_para_latinoamerica',
  },
  {
    id: 'ein-que-es-como-obtenerlo',
    slug: 'ein-que-es-como-obtenerlo',
    category: 'llc-basics',
    featured: false,
    publishedAt: '2025-01-05',
    readingTime: 8,
    author: 'Rely',
    title: {
      es: 'EIN: qué es, para qué sirve y cómo obtenerlo para tu LLC',
      en: 'EIN: what it is, what it is for and how to obtain it for your LLC',
    },
    excerpt: {
      es: 'El EIN es el número de identificación fiscal de tu LLC en Estados Unidos. Aprendé qué es, para qué lo necesitás y cómo obtenerlo de forma rápida.',
      en: 'The EIN is your LLC tax identification number in the United States. Learn what it is, why you need it and how to get it quickly.',
    },
    file: '05_ein_que_es_como_obtenerlo',
  },
  {
    id: 'boir-fincen-explicado',
    slug: 'boir-fincen-explicado',
    category: 'llc-basics',
    featured: false,
    publishedAt: '2025-01-06',
    readingTime: 10,
    author: 'Rely',
    title: {
      es: 'BOIR y FinCEN explicado: el nuevo requisito obligatorio para todas las LLC',
      en: 'BOIR and FinCEN explained: the new mandatory requirement for all LLCs',
    },
    excerpt: {
      es: 'Desde 2024, todas las LLC deben reportar sus beneficiarios finales al FinCEN. Conocé qué es el BOIR, quiénes deben presentarlo y cómo hacerlo.',
      en: 'Since 2024, all LLCs must report their beneficial owners to FinCEN. Learn what BOIR is, who must file it and how to do it.',
    },
    file: '06_boir_fincen_explicado',
  },
  {
    id: 'costos-reales-mantener-llc',
    slug: 'costos-reales-mantener-llc',
    category: 'llc-basics',
    featured: false,
    publishedAt: '2025-01-07',
    readingTime: 10,
    author: 'Rely',
    title: {
      es: 'Los costos reales de mantener una LLC en Wyoming',
      en: 'The real costs of maintaining an LLC in Wyoming',
    },
    excerpt: {
      es: 'Desglosamos todos los costos anuales de mantener tu LLC activa: agente registrado, annual report, contabilidad y más. Sin sorpresas.',
      en: 'We break down all the annual costs of keeping your LLC active: registered agent, annual report, accounting and more. No surprises.',
    },
    file: '07_costos_reales_mantener_llc',
  },
  {
    id: 'cobrar-dolares-argentina',
    slug: 'cobrar-dolares-argentina',
    category: 'country-guides',
    featured: false,
    publishedAt: '2025-01-08',
    readingTime: 15,
    author: 'Rely',
    title: {
      es: 'Cómo cobrar en dólares desde Argentina en 2025: guía completa para freelancers',
      en: 'How to collect dollars from Argentina in 2025: complete guide for freelancers',
    },
    excerpt: {
      es: 'Cepo, restricciones, tipo de cambio oficial vs blue. Descubrí las opciones reales para cobrar tus ingresos internacionales desde Argentina.',
      en: 'Currency controls, restrictions, official vs blue exchange rate. Discover real options to collect your international income from Argentina.',
    },
    file: '08_cobrar_dolares_argentina',
  },
  {
    id: 'cobrar-dolares-mexico',
    slug: 'cobrar-dolares-mexico',
    category: 'country-guides',
    featured: false,
    publishedAt: '2025-01-09',
    readingTime: 12,
    author: 'Rely',
    title: {
      es: 'Cómo cobrar en dólares desde México: guía completa para freelancers',
      en: 'How to collect dollars from Mexico: complete guide for freelancers',
    },
    excerpt: {
      es: 'México tiene Stripe, pero ¿una LLC sigue siendo conveniente? Analizamos cuándo vale la pena y cómo optimizar tus ingresos internacionales.',
      en: 'Mexico has Stripe, but is an LLC still worth it? We analyze when it is worth it and how to optimize your international income.',
    },
    file: '09_cobrar_dolares_mexico',
  },
  {
    id: 'cobrar-dolares-colombia',
    slug: 'cobrar-dolares-colombia',
    category: 'country-guides',
    featured: false,
    publishedAt: '2025-01-10',
    readingTime: 12,
    author: 'Rely',
    title: {
      es: 'Cómo cobrar en dólares desde Colombia: guía completa para freelancers',
      en: 'How to collect dollars from Colombia: complete guide for freelancers',
    },
    excerpt: {
      es: 'Colombia tiene sus propias reglas para ingresos del exterior. Conocé las mejores prácticas para freelancers colombianos con clientes internacionales.',
      en: 'Colombia has its own rules for foreign income. Learn the best practices for Colombian freelancers with international clients.',
    },
    file: '10_cobrar_dolares_colombia',
  },
  {
    id: 'llc-vs-autonomo-espana',
    slug: 'llc-vs-autonomo-espana',
    category: 'country-guides',
    featured: false,
    publishedAt: '2025-01-11',
    readingTime: 12,
    author: 'Rely',
    title: {
      es: 'LLC vs Autónomo en España: ¿cuál te conviene más?',
      en: 'LLC vs Autónomo in Spain: which one suits you best?',
    },
    excerpt: {
      es: 'Ser autónomo en España tiene sus desventajas. Comparamos costos, impuestos y beneficios de una LLC americana vs ser autónomo español.',
      en: 'Being self-employed in Spain has its disadvantages. We compare costs, taxes and benefits of an American LLC vs being a Spanish autónomo.',
    },
    file: '11_llc_vs_autonomo_espana',
  },
  {
    id: 'errores-comunes-abrir-llc',
    slug: 'errores-comunes-abrir-llc',
    category: 'llc-basics',
    featured: false,
    publishedAt: '2025-01-12',
    readingTime: 10,
    author: 'Rely',
    title: {
      es: 'Los 10 errores más comunes al abrir una LLC (y cómo evitarlos)',
      en: 'The 10 most common mistakes when opening an LLC (and how to avoid them)',
    },
    excerpt: {
      es: 'Después de ayudar a cientos de emprendedores, recopilamos los errores más frecuentes. Evitá caer en estas trampas con tu LLC.',
      en: 'After helping hundreds of entrepreneurs, we compiled the most frequent mistakes. Avoid falling into these traps with your LLC.',
    },
    file: '12_errores_comunes_abrir_llc',
  },
  {
    id: 'configurar-stripe-llc',
    slug: 'configurar-stripe-llc',
    category: 'payments',
    featured: false,
    publishedAt: '2025-01-13',
    readingTime: 10,
    author: 'Rely',
    title: {
      es: 'Cómo configurar Stripe paso a paso con tu LLC',
      en: 'How to set up Stripe step by step with your LLC',
    },
    excerpt: {
      es: 'Tutorial detallado para configurar Stripe con tu LLC de Wyoming. Qué información necesitás, cómo verificar tu cuenta y empezar a cobrar.',
      en: 'Detailed tutorial to configure Stripe with your Wyoming LLC. What information you need, how to verify your account and start collecting.',
    },
    file: '13_configurar_stripe_llc',
  },
  {
    id: 'guia-impuestos-llc',
    slug: 'guia-impuestos-llc',
    category: 'taxes',
    featured: false,
    publishedAt: '2025-01-14',
    readingTime: 12,
    author: 'Rely',
    title: {
      es: 'Guía de impuestos para LLC de extranjeros: lo que realmente necesitás saber',
      en: 'Tax guide for foreign-owned LLCs: what you really need to know',
    },
    excerpt: {
      es: 'Impuestos en USA, impuestos en tu país, declaraciones obligatorias. Desmitificamos el tema fiscal para dueños de LLC que viven fuera de Estados Unidos.',
      en: 'US taxes, taxes in your country, mandatory filings. We demystify the tax topic for LLC owners who live outside the United States.',
    },
    file: '14_guia_impuestos_llc',
  },
  {
    id: 'trading-inversiones-llc',
    slug: 'trading-inversiones-llc',
    category: 'banking',
    featured: false,
    publishedAt: '2025-01-15',
    readingTime: 12,
    author: 'Rely',
    title: {
      es: 'Trading e inversiones con tu LLC: cómo acceder a brokers de USA',
      en: 'Trading and investments with your LLC: how to access US brokers',
    },
    excerpt: {
      es: 'Tu LLC te abre las puertas a Interactive Brokers, TD Ameritrade y otros brokers estadounidenses. Aprendé cómo configurar tu cuenta de inversiones.',
      en: 'Your LLC opens the doors to Interactive Brokers, TD Ameritrade and other US brokers. Learn how to set up your investment account.',
    },
    file: '15_trading_inversiones_llc',
  },
  {
    id: 'crs-2-dac8-arca-2026',
    slug: 'crs-2-dac8-arca-2026',
    category: 'regulations',
    featured: true,
    publishedAt: '2026-02-05',
    readingTime: 15,
    author: 'Rely',
    title: {
      es: 'CRS 2.0 y DAC8: Lo que ARCA sabrá de tus billeteras digitales y criptoactivos desde 2026',
      en: 'CRS 2.0 and DAC8: What Tax Authorities Will Know About Your Digital Wallets and Crypto in 2026',
    },
    excerpt: {
      es: 'Desde febrero 2026, ARCA recibirá información automática sobre billeteras virtuales, exchanges de cripto y plataformas de pago internacionales. Entendé qué cambia, qué se reporta y cómo prepararte.',
      en: 'Starting February 2026, tax authorities will receive automatic information about virtual wallets, crypto exchanges, and international payment platforms. Understand what changes, what gets reported, and how to prepare.',
    },
    file: '16_crs_2_dac8_arca_2026',
  },
];

/**
 * Get all blogs
 */
export const getAllBlogs = () => blogs;

/**
 * Get featured blogs
 */
export const getFeaturedBlogs = () => blogs.filter((blog) => blog.featured);

/**
 * Get blog by slug
 */
export const getBlogBySlug = (slug) => blogs.find((blog) => blog.slug === slug);

/**
 * Get blogs by category
 */
export const getBlogsByCategory = (category) =>
  category === 'all'
    ? blogs
    : blogs.filter((blog) => blog.category === category);

/**
 * Search blogs by query
 */
export const searchBlogs = (query, language = 'es') => {
  if (!query || query.trim() === '') return blogs;

  const normalizedQuery = query.toLowerCase().trim();

  return blogs.filter((blog) => {
    const title = blog.title[language]?.toLowerCase() || '';
    const excerpt = blog.excerpt[language]?.toLowerCase() || '';
    return title.includes(normalizedQuery) || excerpt.includes(normalizedQuery);
  });
};

/**
 * Get category info
 */
export const getCategoryInfo = (categoryId) => BLOG_CATEGORIES[categoryId];

/**
 * Get all categories
 */
export const getAllCategories = () => Object.values(BLOG_CATEGORIES);

export default blogs;
